// extracted by mini-css-extract-plugin
export default {"iconColor":"#44cc94","column":"column__1sMmP","content":"content__1ewHI","headerTitle":"headerTitle__wY_JV","iconContainer":"iconContainer__3uP7_","headerContainer":"headerContainer__IXJ5R","subHeaderContainer":"subHeaderContainer__3fqnk","priceAmount":"priceAmount__31i6P","priceTTC":"priceTTC__iGEfu","paymentMethodDetail":"paymentMethodDetail__1pa5Y"};
    if(module.hot) {
      // 1713425460710
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  